export default __webpack_public_path__ + "static/tiles-10-be1c6af92cc43565fef5855cef58dfd8.webp";